export default __webpack_public_path__ + "static/encuentra_la_pareja_pc-3705460a8800c0c9f5c596e2dc55cd9b.png";